import { CustomValidatorArgs } from '../types/CSVTypes';

const MAX_TAGS_PER_ORDER = 20;
const MAX_TAG_LENGTH = 128;

// Tag names can only contain letters, numbers, dashes, and spaces
const VALID_TAG_PATTERN = /^[a-zA-Z0-9- ]+$/;


const tagsValidator = ({ value }: CustomValidatorArgs) => {
  if (!value || value.trim() === '') {
    return null;
  }

  // Split comma-separated tags and count them
  const tags = String(value)
    .split(',')
    .map((tag) => tag.trim())
    .filter((tag) => tag.length > 0);

  if (tags.some((tag) => !VALID_TAG_PATTERN.test(tag))) {
    return 'invalidTagCharacters';
  }

  if (tags.length > MAX_TAGS_PER_ORDER) {
    return 'tooManyTags';
  }

  // Check each tag length
  for (const tag of tags) {
    if (tag.length > MAX_TAG_LENGTH) {
      return 'tagTooLong';
    }
  }

  return null;
};

export default tagsValidator;
